import { render, staticRenderFns } from "./dialog-password.vue?vue&type=template&id=6cc77d3d&"
import script from "./dialog-password.vue?vue&type=script&lang=js&"
export * from "./dialog-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports